import React from 'react'
import styled from 'styled-components'
import { withRouter, Link } from 'react-router-dom'
import * as Settings from './Settings.js'
import logoSrc from '../assets/logo.svg'

const TopMenuContainer = styled.div`
    grid-row: 1;
    align-self: center;
    justify-self: center;
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 180px;
    grid-column-gap: 15px;
    margin-top: 20px;
`

const HomeLink = styled(Link)`
    display: inline-block;
    align-self: center;
`

const LogoImage = styled.img`
    height: 40px; // Adjust this value as needed
    width: auto;
`

const PlayerLinks = styled.div`
    align-self: center;
    justify-self: center;
    display: inline-block;
    margin-left: 20px;

    @media (max-width: 700px) {
        position: absolute;
        top: 28px;
        overflow: scroll;
        max-width: 160px;
    }
`

const PlayerLink = styled(Link)`
    font-size: 1.4rem;
    font-weight: 300;
    color: var(--teal-0);
    margin-right: 1rem;

    &:hover {
        color: #ef3d64;
    }
`

const RightLinks = styled.div`
    align-self: center;
    justify-self: end;

    a {
        text-transform: uppercase;
        font-size: 1.0rem;
        font-weight: 400;
        color: var(--teal-0);
        grid-column: 2;
        margin-left: 15px;

        &:hover {
            color: #ef3d64;
        }
    }
`

const createPlayerLinks = favoritePlayers => {
    return favoritePlayers.map(f => {
        const isMultiShard = favoritePlayers.some(f2 => f2.name === f.name && f2.shardId !== f.shardId)
        const link = `/${f.name}/${f.shardId}`
        const name = isMultiShard ? `${f.name} (${f.shardId})` : f.name

        return <PlayerLink to={link} key={link}>{name}</PlayerLink>
    })
}

class TopMenu extends React.Component {
    state = {}

    handleFile = e => {
        this.props.history.push('/local-replay', { file: e.target.files[0] })
        e.target.value = null // reset so we can select the same file again
    }

    render() {
        return (
            <Settings.Context.Consumer>
                {({ favoritePlayers }) => (
                    <TopMenuContainer>
                        <div>
                            <HomeLink to="#">
                                <LogoImage src={logoSrc} alt="eWave Logo" />
                            </HomeLink>
                            <PlayerLinks>{createPlayerLinks(favoritePlayers)}</PlayerLinks>
                        </div>
                        <RightLinks>
                            <Link to="https://ewave.gg" target="_blank">Return to platform</Link>
                        </RightLinks>
                    </TopMenuContainer>
                )}
            </Settings.Context.Consumer>
        )
    }
}

export default withRouter(TopMenu)


// WEBPACK FOOTER //
// src/components/TopMenu.js